import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=0fe9044e&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=js&"
export * from "./Work.vue?vue&type=script&lang=js&"
import style0 from "../style/work.css?vue&type=style&index=0&id=0fe9044e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe9044e",
  null
  
)

export default component.exports